import PlatformFormContainer from './PlatformForm.container'

export default PlatformFormContainer